"use client";
import { FC } from "react";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { InternalSearchResults } from "@/components/InternalSearch";

type InternalSearchResultsBlockProps = {
  variant: "swdc" | "support";
  resultsText?: string;
  loadingText?: string;
  noResultsTitle?: string;
  noResultsSuggestion?: string;
  previousCTAText?: string;
  previousCTADLD?: string;
  previousCTADLT?: string;
  nextCTAText?: string;
  nextCTADLD?: string;
  nextCTADLT?: string;
} & BuilderProps;

export const InternalSearchResultsBlock: FC<
  InternalSearchResultsBlockProps
> = ({
  variant = "swdc",
  resultsText,
  loadingText,
  noResultsTitle,
  noResultsSuggestion,
  previousCTAText,
  previousCTADLD,
  previousCTADLT,
  nextCTAText,
  nextCTADLD,
  nextCTADLT,
}) => {
  return (
    <InternalSearchResults
      variant={variant}
      resultsText={resultsText}
      loadingText={loadingText}
      noResultsTitle={noResultsTitle}
      noResultsSuggestion={noResultsSuggestion}
      previousButtonText={previousCTAText}
      previousButtonDLD={previousCTADLD}
      previousButtonDLT={previousCTADLT}
      nextButtonText={nextCTAText}
      nextButtonDLD={nextCTADLD}
      nextButtonDLT={nextCTADLT}
    />
  );
};
